<script setup lang="ts">
import GoogleAddressAutocomplete from 'vue3-google-address-autocomplete';

import { GOOGLE_MAPS_API_KEY } from '@idem/common/constantes';

defineProps<{ modelValue: string; placeholder?: string }>();
const emit = defineEmits<{
  'update:modelValue': [direccion: string];
  coordenadas: [coordenadas: { latitud: number; longitud: number }];
}>();

function seleccionarLugar(lugar: any) {
  const numero = lugar.address_components.find(componente =>
    componente.types.some(tipo => tipo === 'street_number'),
  ).short_name;
  const calle = lugar.address_components.find(componente =>
    componente.types.some(tipo => tipo === 'route'),
  ).short_name;
  const ciudad = lugar.address_components.find(componente =>
    componente.types.some(tipo => tipo === 'administrative_area_level_3'),
  ).short_name;

  emit('update:modelValue', `${calle} ${numero}, ${ciudad}`);
  emit('coordenadas', {
    latitud: lugar.geometry.location.lat(),
    longitud: lugar.geometry.location.lng(),
  });
}
</script>

<template>
  <google-address-autocomplete
    :apiKey="GOOGLE_MAPS_API_KEY || 'NO_API_KEY_PROVIDED'"
    :modelValue="modelValue"
    data-testid="direccion-input"
    :placeholder="placeholder"
    @keydown.enter="e => e.preventDefault()"
    @callback="seleccionarLugar"
  />
</template>
